import styled from "styled-components";
import ToggleButton from "./Toggle";

export const Button = styled.button`
  background: linear-gradient(267.28deg, #7b61ff 24%, #aa82ff 73.95%);
  backdrop-filter: blur(2px);
  // padding: 0.75rem 2.5rem;
  border-radius: 999px;
  color: white;
  width: auto;
`;

export {
  ToggleButton
}